package ru.it_mozaika.sender.js.application.context

import io.ktor.client.call.*
import io.ktor.client.statement.*
import io.ktor.http.*
import js.core.jso
import oldcomponents.NotyType
import react.*
import ru.it_mozaika.sender.common.models.*
import ru.it_mozaika.sender.js.application.Http
import ru.it_mozaika.utils.checkResponseError

external interface SubscriberContextInterface {
    var currentSubscriber: SubscriberData?
    var update: (SubscriberData?) -> Unit
    var isSaved: Boolean
    var save: () -> Unit
    var load: (String) -> Unit
    var updatedSubscriber: SubscriberData?
    var cancelChanges: () -> Unit
}

val SubscriberContext = createContext<SubscriberContextInterface>(jso {
    currentSubscriber = null
    update = {}
    isSaved = false
    save = {}
    load = {}
    updatedSubscriber = null
    cancelChanges = {}
})

val SubscriberProvider = FC<PropsWithChildren> { props ->
    val backDrop = useBackdrop()
    val storeContext = useStore()
    val requestResultContext = useContext(RequestResultContext)
    var currentSubscriber by useState<SubscriberData>()
    val (newData, setNewData) = useState<SubscriberData>()
    var isSaved by useState(true)
    useEffect(currentSubscriber) {
        currentSubscriber?.store?.let { storeContext.setStore(it) }
        setNewData(currentSubscriber)
    }
    SubscriberContext.Provider {
        value = jso {
            this.cancelChanges = {
                setNewData(currentSubscriber)
                isSaved = true
            }
            this.updatedSubscriber = newData
            this.currentSubscriber = currentSubscriber
            this.update = {
                setNewData(it)
                isSaved = false
            }
            this.load = { id ->
                getSubscriber(id) { it ->
                    currentSubscriber = it
                }
            }
            this.isSaved = isSaved
            this.save = useMemo(newData) {
                save@{
                    if (isSaved)
                        return@save
                    backDrop.show()
                    if (newData != null) {
                        saveSubscriber(
                            newData
                        ) { response ->
                            requestResultContext.handleRequestRespond(response)
                            getSubscriber(newData.id) {
                                currentSubscriber = it
                            }
                            isSaved = true
                            backDrop.hide()
                        }
                    }
                }
            }
        }
        +props.children
    }
}
@Suppress("DeferredResultUnused")
fun saveSubscriber(data: SubscriberData,  callback: (HttpResponse) -> Unit ) {
        Http.put(
            "/subscribers/${data.id}",
            data,
            callback = { callback(it) }
        )
}
fun getSubscriber(id: String, callback: (SubscriberData) -> Unit){
    Http.get("/subscribers/$id") { response ->
        response.checkResponseError()?.let {
            oldcomponents.showNotification(it, NotyType.Error)
            return@get
        }
        callback(response.body())
    }
}

